import { useLayoutEffect, useRef, useState } from 'react';

const isElementFullyVisible = element => {
  const elementRect = element.getBoundingClientRect();
  const parentRect = element.parentElement.getBoundingClientRect();

  return (
    elementRect.top >= parentRect.top &&
    elementRect.bottom <= parentRect.bottom &&
    elementRect.left >= parentRect.left &&
    elementRect.right <= parentRect.right
  );
};

export default function useIsFullyVisible(deps = []) {
  const [fullyVisible, setFullyVisible] = useState(false);
  const ref = useRef();

  useLayoutEffect(() => {
    if (ref.current) {
      setFullyVisible(isElementFullyVisible(ref.current));
    } else {
      setFullyVisible(false);
    }
  }, deps);

  return [fullyVisible, ref];
}
